import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import axios from 'axios';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { loadCss } from 'esri-loader';
import { LicenseManager } from 'ag-grid-enterprise';
import { HeadProvider } from 'react-head';

import 'react-datepicker/dist/react-datepicker.css';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';

import { store } from './store';
import en from './lang/en.json';
import theme from './theme/index';
import { msalInstance } from './services/auth';

import './index.css';

import './analytics.js';
import { RouterProvider } from 'react-router-dom';
import { router } from 'routes';

axios.defaults.baseURL = process.env.REACT_APP_API;

LicenseManager.setLicenseKey(process.env.REACT_APP_GRID_KEY);

loadCss();

const translations = {
    en,
};

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <MsalProvider instance={msalInstance}>
            <Provider store={store}>
                <ChakraProvider theme={theme}>
                    <ColorModeScript
                        type="localStorage"
                        storageKey={'psv-color-mode'}
                        initialColorMode={theme?.config?.initialColorMode || 'light'}
                    />
                    <HeadProvider>
                        <IntlProvider defaultLocale="en" locale="en" messages={translations.en}>
                            <RouterProvider router={router} />
                        </IntlProvider>
                    </HeadProvider>
                </ChakraProvider>
            </Provider>
        </MsalProvider>
    </StrictMode>
);
